import type { AppState } from "@auth0/auth0-react"
import { Auth0Provider } from "@auth0/auth0-react"
import React from "react"
import { useNavigate } from "react-router-dom"
import { loadEnvVars } from "../utils/loadEnvVars"

export const Auth0ProviderWithNavigate = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate()

  const { auth0Domain, auth0ClientId, auth0Audience, auth0RedirectUri } = loadEnvVars()

  const onRedirectCallback = (appState: AppState | undefined) => {
    navigate(appState?.returnTo || window.location.pathname)
  }

  if (!(auth0Domain && auth0ClientId && auth0RedirectUri)) {
    throw new Error("Please set auth0 env. variables")
  }

  return (
    <Auth0Provider
      domain={auth0Domain}
      clientId={auth0ClientId}
      authorizationParams={{
        redirect_uri: auth0RedirectUri,
        audience: auth0Audience
      }}
      onRedirectCallback={onRedirectCallback}
      cacheLocation="localstorage"
    >
      {children}
    </Auth0Provider>
  )
}
